import { Fragment, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import UIList from 'UIComponents/list/UIList';
import { getId } from 'find-and-filter-data/views-schema/public';
import { useLocalStorage } from '../../../local-storage/hooks/useLocalStorage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Carat = styled(UIIcon).withConfig({
  displayName: "MoreLinksAccordion__Carat",
  componentId: "sc-1wrqtf-0"
})(["color:", ";transform:", ";transition:transform 150ms ease;"], CALYPSO_DARK, ({
  open
}) => open && 'rotate(90deg)');
const Header = styled.span.withConfig({
  displayName: "MoreLinksAccordion__Header",
  componentId: "sc-1wrqtf-1"
})(["display:flex;justify-content:space-between;align-items:center;cursor:pointer;padding:8px 24px 8px 12px;width:100%;transition:color 150ms ease;:hover{color:", ";}"], CALYPSO_DARK);
const viewHasId = id => view => getId(view) === id;
const MORE_LINKS_ACCORDION_STATE = 'MORE_LINKS_ACCORDION_STATE';
const OPEN = 'OPEN';
const CLOSED = 'CLOSED';
const MoreLinksAccordion = ({
  currentViewId,
  views,
  viewRenderer
}) => {
  const previousViewId = useRef(currentViewId);
  const [moreLinksAccordionState, setMoreLinksAccordionState] = useLocalStorage({
    key: MORE_LINKS_ACCORDION_STATE,
    initialValue: views.some(viewHasId(currentViewId)) ? OPEN : CLOSED
  });
  const isOpen = moreLinksAccordionState === OPEN;
  const toggleHeader = useCallback(() => setMoreLinksAccordionState(moreLinksAccordionState === OPEN ? CLOSED : OPEN), [moreLinksAccordionState, setMoreLinksAccordionState]);
  useEffect(() => {
    if (!isOpen && previousViewId.current !== currentViewId && views.some(viewHasId(currentViewId))) {
      setMoreLinksAccordionState(OPEN);
    }
  }, [currentViewId, isOpen, previousViewId, views, setMoreLinksAccordionState]);
  useEffect(() => {
    previousViewId.current = currentViewId;
  }, [currentViewId]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(Header, {
      onClick: toggleHeader,
      "data-test-id": "more-views-dropdown-button",
      children: [isOpen ? I18n.text('svh-workspace-ui-lib.navigation-sidebar.seeLessViewsToggle') : I18n.text('svh-workspace-ui-lib.navigation-sidebar.seeMoreViewsToggle'), /*#__PURE__*/_jsx(Carat, {
        name: "right",
        open: isOpen
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      renderContent: () => /*#__PURE__*/_jsx(UIList, {
        "data-test-id": "more-views-list",
        children: views.map(viewRenderer)
      }),
      open: isOpen
    })]
  });
};
MoreLinksAccordion.displayName = 'MoreLinksAccordion';
export default MoreLinksAccordion;